import React from 'react';

interface LinkProps {
    url: string;
    text: string;
}

const CustomLink: React.FC<LinkProps> = ({ url, text }) => {
    return (
        <a className="text-[rgb(245,158,11)] no-underline transition-colors duration-150 ease-in-out hover:underline" href={url} target="_blank" rel="noreferrer">{text}</a>
    );
};

export default CustomLink;
